import React, { ReactElement } from 'react'
import { connectMenu } from 'react-instantsearch-dom'
import { Select } from '@mindfulchefuk/design-system/Forms'
import { MenuProvided } from 'react-instantsearch-core'

export const UnconnectedMenuSelect = ({
  currentRefinement,
  items,
  refine,
}: MenuProvided): ReactElement => (
  <Select
    onChange={(event) => refine(event.currentTarget.value)}
    data-testid="select"
    value={currentRefinement || ''}
  >
    <option value="">All</option>
    {items.map((item) => (
      <option
        key={item.label}
        value={item.isRefined ? currentRefinement : item.value}
      >
        {item.label}
      </option>
    ))}
  </Select>
)

export const MenuSelect = connectMenu(UnconnectedMenuSelect)
